import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

export default function NumericKeypadDropdown({
  anchorRef,
  onSelect,
  onClose,
}) {
  const values = [
    "0.25",
    "0.5",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
  ];
  const anchorEl = anchorRef?.current;

  const [style, setStyle] = useState(null);

  useEffect(() => {
    if (!anchorEl) return;

    const rect = anchorEl.getBoundingClientRect();

    setStyle({
      position: "fixed",
      top: rect.bottom + 6,
      left: rect.left,
      background: "#fff",
      border: "1px solid #ccc",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      padding: "12px",
      zIndex: 9999,
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: "10px",
      width: "auto",
    });
  }, [anchorEl]);

  useEffect(() => {
    const handleOutside = (e) => {
      if (
        anchorEl &&
        !anchorEl.contains(e.target) &&
        !e.target.closest(".numeric-keypad-dropdown")
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, [anchorEl, onClose]);

  if (!style) return null;

  return ReactDOM.createPortal(
    <div className="numeric-keypad-dropdown" style={style}>
      {values.map((val) => (
        <button
          key={val}
          onMouseDown={(e) => {
            e.stopPropagation();
            onSelect(parseFloat(val));
            onClose();
          }}
          style={{
            padding: "14px",
            fontSize: "18px",
            background: "#f9f9f9",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          {val}
        </button>
      ))}
    </div>,
    document.body
  );
}
